(function() {
  'use strict';

  function parseNumberInput(value) {
    if (typeof value == 'number') {
      return Number.isFinite(value) ? value : 0;
    }
    if (typeof value != 'string') {
      return 0;
    }
    const trimmed = value.trim();
    if (!trimmed) {
      return 0;
    }

    const sanitized = trimmed.replace(/[^0-9,.-]/g, '');
    if (!sanitized) {
      return 0;
    }
    const hasComma = sanitized.includes(',');
    const hasDot = sanitized.includes('.');
    const commaCount = hasComma ? (sanitized.match(/,/g) || []).length : 0;
    const dotCount = hasDot ? (sanitized.match(/\./g) || []).length : 0;
    let normalized = sanitized;

    if (hasComma && hasDot) {
      const lastComma = sanitized.lastIndexOf(',');
      const lastDot = sanitized.lastIndexOf('.');
      if (lastComma > lastDot) {
        normalized = sanitized.replace(/\./g, '').replace(',', '.');
      } else {
        normalized = sanitized.replace(/,/g, '');
      }
    } else if (hasComma) {
      // 仅在出现多个分隔符时按千分位处理，避免把 0,996 解析成 996
      if (commaCount > 1 && /^\d{1,3}(,\d{3})+$/.test(sanitized)) {
        normalized = sanitized.replace(/,/g, '');
      } else {
        normalized = sanitized.replace(',', '.');
      }
    } else if (dotCount > 1 && /^\d{1,3}(\.\d{3})+$/.test(sanitized)) {
      // 仅在出现多个分隔符时按千分位处理，避免把 8.135 解析成 8135
      normalized = sanitized.replace(/\./g, '');
    }

    const parsed = Number.parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function normalizeWeightKg(rawValue, unitHint) {
    const numericWeight = parseNumberInput(rawValue);
    if (!numericWeight) {
      return 0;
    }
    const unitSource = `${unitHint || ''} ${typeof rawValue === 'string' ? rawValue : ''}`.toLowerCase();
    if (unitSource.includes('kg')) {
      return numericWeight;
    }
    if (unitSource.includes('g')) {
      return numericWeight / 1000;
    }
    if (numericWeight >= 100) {
      return numericWeight / 1000;
    }
    return numericWeight;
  }

  // 从data属性获取汇率（从shop metafield）
  const container = document.getElementById('product-data-container');
  if (!container) {
    console.warn('[初始化] 未找到产品预估总计容器，跳过初始化');
    return;
  }

  const EXCHANGE_RATE = parseNumberInput(container.getAttribute('data-exchange-rate')) || 8.2803;
  const collectionExchangeRateRaw = parseNumberInput(container.getAttribute('data-collection-exchange-rate'));
  const COLLECTION_EXCHANGE_RATE = collectionExchangeRateRaw > 0 ? collectionExchangeRateRaw : (1 / EXCHANGE_RATE);
  const CUSTOMS_THRESHOLD_CNY = 50; // 关税门槛（人民币）
  const SHIPPING_RATES = Array.isArray(window.SHIPPING_RATES) ? window.SHIPPING_RATES : [];

  console.log('[初始化] 结算汇率: ' + EXCHANGE_RATE.toFixed(4) + ' EUR/CNY');
  console.log('[初始化] 收款汇率: ' + COLLECTION_EXCHANGE_RATE.toFixed(6) + ' EUR/CNY');

  function calculateShipping(weightKg) {
    let regular = 0.0;
    let silver = 0.0;
    let gold = 0.0;

    console.log('[运费计算] 输入重量:', weightKg, 'kg');

    const matchedRate = SHIPPING_RATES.find((rate) => weightKg >= rate.min && weightKg <= rate.max);
    const fallbackRate = SHIPPING_RATES[SHIPPING_RATES.length - 1];
    const activeRate = matchedRate || fallbackRate;

    if (activeRate) {
      regular = Number(activeRate.standard) || 0;
      silver = Number(activeRate.silver) || 0;
      gold = Number(activeRate.gold) || 0;
    }

    if (!matchedRate && weightKg > 100) {
      console.log('[运费计算] 重量超过100kg，使用最高档价格或需要人工询价');
    }

    console.log(
      '[运费计算] 匹配结果 - 普通: €' + regular.toFixed(2) +
      ', 银卡: €' + silver.toFixed(2) +
      ', 金卡: €' + gold.toFixed(2)
    );
    return { regular, silver, gold };
  }

  // 获取DOM元素
  const elements = {
    qtyInput: document.getElementById('quantity-input'),
    qtyMinus: document.getElementById('qty-minus'),
    qtyPlus: document.getElementById('qty-plus'),
    productPrice: document.getElementById('product-price'),
    shippingWeightBadge: document.getElementById('shipping-weight-badge'),
    shippingStandard: document.getElementById('shipping-standard'),
    shippingSilver: document.getElementById('shipping-silver'),
    shippingVip: document.getElementById('shipping-vip'),
    duty: document.getElementById('duty'),
    customsWaivedHint: document.getElementById('customs-waived-hint'),
    warningInfo: document.getElementById('warning-info'),
    dutyRateBadge: document.getElementById('duty-rate-badge'),
    totalStandard: document.getElementById('total-standard'),
    totalSilver: document.getElementById('total-silver'),
    totalVip: document.getElementById('total-vip'),
    debugInfo: document.getElementById('debug-info')
  };

  function getProductData() {
    const container = document.getElementById('product-data-container');
    if (!container) {
      console.error('[错误] 产品数据容器未找到!');
      return { price: 0, weight: 0, customsRate: 13 };
    }

    let price = 0;
    
    // 获取促销价元素
    const priceElement = document.querySelector('.price-item.price-item--sale');
    
    if (priceElement) {
      const priceText = priceElement.textContent.trim();
      console.log('[价格获取] 原始文本: "' + priceText + '"');
      
      const parsedPrice = parseNumberInput(priceText);

      if (parsedPrice > 0) {
        price = parsedPrice;
        console.log('[价格获取] 从促销价获取: €' + price.toFixed(2));
      }
    } else {
      // 没有促销价，使用常规价
      const regularElement = document.querySelector('.price__regular .price-item--regular');
      if (regularElement) {
        const priceText = regularElement.textContent.trim();
        const parsedPrice = parseNumberInput(priceText);
        if (parsedPrice > 0) {
          price = parsedPrice;
          console.log('[价格获取] 从常规价获取: €' + price.toFixed(2));
        }
      }
    }
    
    // 回退方案
    if (!price || price === 0) {
      price = parseNumberInput(container.getAttribute('data-product-price')) || 0;
      console.log('[价格获取] 从data属性获取: €' + price.toFixed(2));
    }

    const rawWeight = container.getAttribute('data-product-weight');
    const weightUnitHint = container.getAttribute('data-product-weight-unit');
    const weight = normalizeWeightKg(rawWeight, weightUnitHint);
    const customsRate = parseNumberInput(container.getAttribute('data-customs-rate')) || 13;

    console.log('[数据获取] 最终价格: €' + price.toFixed(2) + ', 重量: ' + formatWeightKg(weight) + ', 税率: ' + customsRate + '%');

    return {
      price: price,
      weight: weight,
      customsRate: customsRate
    };
  }

  // 格式化欧元
  function formatEur(amount) {
    return '€' + amount.toFixed(2);
  }

  function formatCny(amount) {
    return '¥' + amount.toFixed(2);
  }

  function renderEstimateTotal(amountEur, amountCny) {
    return (
      '<span class="estimate-money">' +
        '<span class="estimate-money-eur">' + formatEur(amountEur) + '</span>' +
        '<span class="estimate-money-cny">(' + formatCny(amountCny) + ')</span>' +
      '</span>'
    );
  }

  function formatWeightKg(weightKg) {
    return (Math.floor(weightKg * 100) / 100).toFixed(2) + 'kg';
  }

  // 调试日志
  function logDebug(message) {
    const timestamp = new Date().toLocaleTimeString();
    const debugText = elements.debugInfo.textContent;
    elements.debugInfo.textContent = `[${timestamp}] ${message}\n${debugText}`;
  }

  // 更新所有计算
  function updateCalculations() {
    const quantity = parseInt(elements.qtyInput.value) || 1;
    const productData = getProductData();

    console.log('[更新计算] 数量: ' + quantity);

    if (elements.warningInfo) {
      elements.warningInfo.textContent = '税门槛¥' + CUSTOMS_THRESHOLD_CNY + ' | 当月€→¥' + EXCHANGE_RATE.toFixed(4) + ' | 当月¥→€' + COLLECTION_EXCHANGE_RATE.toFixed(6);
    }

    // 计算总重量（kg）
    const totalWeightKg = productData.weight * quantity;
    console.log('[重量计算] 单品重量: ' + formatWeightKg(productData.weight) + ' × 数量: ' + quantity + ' = 总重量: ' + formatWeightKg(totalWeightKg));

    // 调试信息
    logDebug(`数量: ${quantity}, 单价: €${productData.price.toFixed(2)}, 单品重量: ${formatWeightKg(productData.weight)}, 总重量: ${formatWeightKg(totalWeightKg)}, 税率: ${productData.customsRate}%, 结算汇率: ${EXCHANGE_RATE.toFixed(4)}, 收款汇率: ${COLLECTION_EXCHANGE_RATE.toFixed(6)}`);

    // 更新关税税率显示
    elements.dutyRateBadge.textContent = `(${productData.customsRate}%)`;

    // 商品总价
    const productPrice = productData.price * quantity;
    elements.productPrice.textContent = formatEur(productPrice);

    // 更新重量显示
    elements.shippingWeightBadge.textContent = '(' + formatWeightKg(totalWeightKg) + ')';

    // 获取运费
    const shippingCosts = calculateShipping(totalWeightKg);
    const shippingStandard = shippingCosts.regular;
    const shippingSilver = shippingCosts.silver;
    const shippingVip = shippingCosts.gold;
    elements.shippingStandard.textContent = formatEur(shippingStandard);
    if (elements.shippingSilver) {
      elements.shippingSilver.textContent = formatEur(shippingSilver);
    }
    elements.shippingVip.textContent = formatEur(shippingVip);

    logDebug(`总重量 ${formatWeightKg(totalWeightKg)} 匹配运费: 普通€${shippingStandard.toFixed(2)}, 银卡€${shippingSilver.toFixed(2)}, 金卡€${shippingVip.toFixed(2)}`);

    // 关税计算
    const dutyCny = productPrice * EXCHANGE_RATE * (productData.customsRate / 100);
    const dutyEur = dutyCny * COLLECTION_EXCHANGE_RATE;
    const dutyEurRounded = Number(dutyEur.toFixed(2));
    // 免征判断按前端展示/收取的欧元关税，折算回人民币后与阈值比较，避免双汇率导致口径不一致
    const dutyCnyForThreshold = dutyEurRounded * EXCHANGE_RATE;
    
    console.log('[关税计算] 计税人民币: ¥' + dutyCny.toFixed(2) + ', 收款汇率: ' + COLLECTION_EXCHANGE_RATE.toFixed(6) + ', 展示关税欧元: €' + dutyEurRounded.toFixed(2) + ', 判定人民币: ¥' + dutyCnyForThreshold.toFixed(2));
    
    // 更新关税显示和视觉效果
    elements.duty.textContent = formatEur(dutyEurRounded);
    
    // 判断是否免征关税
    const isCustomsWaived = dutyCnyForThreshold < CUSTOMS_THRESHOLD_CNY;
    
    if (isCustomsWaived) {
      // 关税低于50元人民币 - 显示删除线和灰色
      elements.duty.classList.add('customs-waived');
      elements.customsWaivedHint.textContent = '(免征)';
      console.log('[关税状态] 判定关税¥' + dutyCnyForThreshold.toFixed(2) + ' < ¥50，标记为免征');
    } else {
      // 关税达到50元人民币 - 正常显示
      elements.duty.classList.remove('customs-waived');
      elements.customsWaivedHint.textContent = '';
      console.log('[关税状态] 判定关税¥' + dutyCnyForThreshold.toFixed(2) + ' >= ¥50，需要缴纳');
    }

    logDebug(`关税: €${dutyEurRounded.toFixed(2)} (计税¥${dutyCny.toFixed(2)} / 判定¥${dutyCnyForThreshold.toFixed(2)}) ${isCustomsWaived ? '- 免征' : '- 需缴纳'}`);

    // 总计计算 - 当关税免征时不计入总额
    const actualCustoms = isCustomsWaived ? 0 : dutyEurRounded;
    const totalStandard = productPrice + shippingStandard + actualCustoms;
    const totalSilver = productPrice + shippingSilver + actualCustoms;
    const totalVip = productPrice + shippingVip + actualCustoms;
    
    // 原有的欧元显示 + 人民币参考金额
    const cnyStandard = (totalStandard * EXCHANGE_RATE).toFixed(2);
    const cnySilver = (totalSilver * EXCHANGE_RATE).toFixed(2);
    const cnyVip = (totalVip * EXCHANGE_RATE).toFixed(2);

    elements.totalStandard.innerHTML = renderEstimateTotal(totalStandard, Number(cnyStandard));
    if (elements.totalSilver) {
      elements.totalSilver.innerHTML = renderEstimateTotal(totalSilver, Number(cnySilver));
    }
    elements.totalVip.innerHTML = renderEstimateTotal(totalVip, Number(cnyVip));

    console.log('[总计计算] 实际关税: €' + actualCustoms.toFixed(2) + ' (免征: ' + isCustomsWaived + ')');
    console.log('[计算完成] 普通总计: €' + totalStandard.toFixed(2) + ', 银卡总计: €' + totalSilver.toFixed(2) + ', 金卡总计: €' + totalVip.toFixed(2));
    
    logDebug(`总计: 普通€${totalStandard.toFixed(2)} (商品€${productPrice.toFixed(2)} + 运费€${shippingStandard.toFixed(2)} + 关税€${actualCustoms.toFixed(2)}), 银卡€${totalSilver.toFixed(2)} (商品€${productPrice.toFixed(2)} + 运费€${shippingSilver.toFixed(2)} + 关税€${actualCustoms.toFixed(2)}), 金卡€${totalVip.toFixed(2)} (商品€${productPrice.toFixed(2)} + 运费€${shippingVip.toFixed(2)} + 关税€${actualCustoms.toFixed(2)})`);
  }

  // 数量减少
  elements.qtyMinus.addEventListener('click', () => {
    const current = parseInt(elements.qtyInput.value) || 1;
    if (current > 1) {
      elements.qtyInput.value = current - 1;
      updateCalculations();
    }
  });

  // 数量增加
  elements.qtyPlus.addEventListener('click', () => {
    const current = parseInt(elements.qtyInput.value) || 1;
    if (current < 99) {
      elements.qtyInput.value = current + 1;
      updateCalculations();
    }
  });

  // 数量输入变化
  elements.qtyInput.addEventListener('change', () => {
    let value = parseInt(elements.qtyInput.value) || 1;
    if (value < 1) value = 1;
    if (value > 99) value = 99;
    elements.qtyInput.value = value;
    updateCalculations();
  });

  // 初始化
  console.log('[初始化] 价格估算器已启动');
  updateCalculations();

  // 延迟执行以等待促销价加载
  setTimeout(function() {
    console.log('[延迟更新] 1000ms后重新计算，获取促销价');
    updateCalculations();
  }, 1000);

  setTimeout(function() {
    console.log('[延迟更新] 2000ms后再次计算，确保促销价已加载');
    updateCalculations();
  }, 2000);

  // 监听产品变体变化
  document.addEventListener('variantchange', () => {
    console.log('[事件] 产品变体已变化，重新计算');
    setTimeout(updateCalculations, 100);
  });

  // 暴露调试函数到全局作用域
  window.debugEstimator = {
    getProductData: getProductData,
    updateCalculations: updateCalculations,
    toggleDebug: function() {
      elements.debugInfo.classList.toggle('show');
    },
    calculateShipping: calculateShipping,
    getExchangeRate: function() {
      return EXCHANGE_RATE;
    },
    getCollectionExchangeRate: function() {
      return COLLECTION_EXCHANGE_RATE;
    },
    CUSTOMS_THRESHOLD_CNY: CUSTOMS_THRESHOLD_CNY
  };

  console.log('价格估算器已初始化。使用 window.debugEstimator.toggleDebug() 显示调试信息。');
})();
